<template>
  <div class="sf-show-more"
  >
    <span class="sf-show-more__title" v-html="titleText + (isExpanded ? '.' : '...')" />
    <span class="sf-show-more__expandable-text"
      v-if="isExpanded"
      v-html="expandableText"
    />
    <span class="sf-show-more__button"
      v-if="!isExpanded || showReadLessButton"
      @click="expandText"
      v-html="toggleButtonText"
    />
  </div>
</template>

<script>
export default {
  components: {

  },
  props: {
    titleText: {
      type: String,
      required: true,
      default: '',
    },
    expandableText: {
      type: String,
      required: true,
      default: '',
    },
    showReadLessButton: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      isExpanded: false,
    };
  },
  computed: {
    toggleButtonText() {
      return this.isExpanded ? 'Read less' : 'Read more';
    },
  },
  methods: {
    expandText() {
      this.isExpanded = !this.isExpanded;
    }
  }
};
</script>

<style lang="scss" scoped>
.sf-show-more {
  font-size: 14px;
  margin: var(--sp_24) 0;

  &__button {
    color: var(--c-grey-4);
    cursor: pointer;
  }
}
</style>
